import { useMutation } from '@tanstack/react-query';

import { apiCancellationFunnels } from '../api';

export function useTryToRequestRemoveFunnelPage() {
  const mutateAsync = useMutation({
    mutationFn: async (id: string) => {
      await apiCancellationFunnels.tryToRequestRemoveCancellationFunnelPage(id);
    },
    onSuccess: success => {
      console.log(success);
    },
    onError: error => {
      console.log(error);
    },
  }).mutateAsync;

  return { tryToRequestRemoveFunnelPage: mutateAsync };
}
